import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { identityApi, type IdentityAuditEntry } from '../../api/identity';

export function IdentityAuditPage() {
  const { id = '' } = useParams();
  const [items, setItems] = useState<IdentityAuditEntry[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    identityApi.audit(id).then(setItems).catch((err) => setError(err instanceof Error ? err.message : 'Failed'));
  }, [id]);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to={`/identity/${id}`} className="text-sm text-slate-600 hover:underline">← Identity</Link>
      <h1 className="mt-4 text-2xl font-semibold text-slate-900">Identity Audit</h1>
      {error && <p className="mt-4 text-sm text-red-700">{error}</p>}
      <ul className="mt-6 space-y-3">
        {items.map((item) => (
          <li key={item.id} className="rounded-xl border border-slate-200 bg-white p-4 text-sm">
            <p className="font-medium text-slate-900">{item.action}</p>
            <p className="text-slate-600">Outcome: {item.outcome}</p>
            <p className="mt-1 text-xs text-slate-500">{new Date(item.created_at).toLocaleString()}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
